// 余额看板主页面组件
export default {
  // 新手引导
  finishButton: "完成",

  // 搜索框
  searchPlaceholder: "请输入你要搜索的案件",
  confirmButton: "确认",

  // 标题
  balanceDashboard: "余额看板",
  updateData: "更新数据",

  // 加载和提示
  loading: "拼命加载中",
  tronUpdateInfo: "Tron链数据可手动更新，更新时间：",

  // 下拉选择
  pleaseSelect: "请选择",
  all: "全部",

  // 对话框
  tronUpdateSuccess: "Tron数据更新成功",
  updateSuccessMessage: "更新成功，确认后余额看板数据将同步变化",
  closeButton: "关闭",
  confirmButtonDialog: "确认",

  // 错误信息
  noSearchResult: "你搜索的案件暂无结果！",
  noCaseData: "暂无案件数据，您可以通过画布选择地址加入到案件数据分析",
};
